const SELECTOR = '.wishlist-hero-custom-button';

function mountWishlistControls(root = document) {
  root.querySelectorAll?.(SELECTOR).forEach((element) => {
    if (element.querySelector('button, a, svg') || element.shadowRoot) return;

    document.dispatchEvent(
      new CustomEvent('wishlist-hero-add-to-custom-element', {
        detail: element,
      })
    );
  });
}

function mountWithRetries(root = document) {
  mountWishlistControls(root);
  window.setTimeout(() => mountWishlistControls(root), 500);
  window.setTimeout(() => mountWishlistControls(root), 1_500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => mountWithRetries(), { once: true });
} else {
  mountWithRetries();
}

window.addEventListener('load', () => mountWithRetries(), { once: true });
document.addEventListener('shopify:section:load', (event) => mountWithRetries(event.target));

const DIALOG_LABELS = new Map([
  ['.wishlist-hero-list-header', 'Sign in to sync your wishlist across devices.'],
  ['.wishlist-hero-list-card-footer-delete-all', 'Clear wishlist'],
]);

function customizeWishlistDialog(root = document) {
  for (const [selector, label] of DIALOG_LABELS) {
    const matches = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    for (const element of matches) {
      if (element.textContent.trim() !== label) element.textContent = label;
    }
  }
}

const dialogObserver = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) customizeWishlistDialog(node);
    }
  }
});

function observeWishlistDialog() {
  customizeWishlistDialog();
  dialogObserver.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeWishlistDialog, { once: true });
} else {
  observeWishlistDialog();
}
